import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { Monitor, Moon, Sun } from 'lucide-react';
import { useTheme } from 'next-themes';
import { useEffect, useState } from 'react';

const OPTIONS = [
  { value: 'light', label: 'Light', icon: Sun },
  { value: 'dark', label: 'Dark', icon: Moon },
  { value: 'system', label: 'Auto', icon: Monitor },
] as const;

export const ThemeSelector = () => {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  return (
    <RadioGroup
      // Always controlled: `theme` is unknown until mounted, so fall back to
      // 'system' instead of switching from uncontrolled to controlled.
      value={mounted ? (theme ?? 'system') : 'system'}
      onValueChange={setTheme}
      className="grid grid-cols-3 gap-3"
    >
      {OPTIONS.map(({ value, label, icon: Icon }) => (
        <Label
          key={value}
          htmlFor={`theme-${value}`}
          className="border-input hover:bg-accent has-[[data-state=checked]]:border-ring
            has-[[data-state=checked]]:bg-accent flex cursor-pointer flex-col items-center
            gap-2 rounded-md border p-4 transition-colors"
        >
          <RadioGroupItem
            id={`theme-${value}`}
            value={value}
            className="sr-only"
          />
          <Icon className="size-5" />
          <span className="text-sm font-medium">{label}</span>
        </Label>
      ))}
    </RadioGroup>
  );
};
